import Vue from 'vue'
import VueRouter from 'vue-router'
import Scheduling from '../views/Scheduling'
import errorPage from '@/views/error-page/404'
// import Calendar from '../views/Calendar'
import store from '@/store/index.js'
import { passlessLogin } from "@/api/user";
import { Message } from 'element-ui'
import NewCalendar from '../views/NewCalendar'
import ModelView from '@/views/ModelView'
import TestCalendar from '../views/TestCalendar'
import History from '../views/History'
import FdyCalendar from '../views/FdyCalendar'
import BwcCalendar from '../views/BwcCalendar'

import SystemIndex from '../views/SystemPage/SystemIndex'
import FDYSystem from '../views/SystemPage/FDYSystem'
import BWCSystem from '../views/SystemPage/BWCSystem'
import LDSystem from '../views/SystemPage/LDSystem'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    component: ModelView,
    children: [
      {
        path: '/',
        name: 'newcalendar',
        component: NewCalendar
      },
      {
        path: '/newcalendar',
        name: 'NewCalendar',
        component: NewCalendar,
      },
      {
        path: '/calendar',
        name: 'Calendar',
        component: Scheduling
      },
      {
        path: '/history',
        name: 'history',
        component: History
      },
      {
        path: '/fdyCalendar',
        name: 'fdyCalendar',
        component: FdyCalendar
      },
      {
        path: '/bwcCalendar',
        name: 'bwcCalendar',
        component: BwcCalendar
      }
    ]
  },
  {
    path: '/system',
    name: 'system',
    component: SystemIndex,
    children: [
      {
        path: '/',
        name: 'ldSystem',
        component: LDSystem
      },
      {
        path: '/ldSystem',
        name: 'ldSystem',
        component: LDSystem
      },
      {
        path: '/fdySystem',
        name: 'fdySystem',
        component: FDYSystem
      },
      {
        path: '/bwcSystem',
        name: 'bwcSystem',
        component: BWCSystem
      },

    ]
  },
  {
    path: '/404',
    component: errorPage,
    hidden: true
  },
  {
    path: '/testCalendar',
    name: 'testCalendar',
    component: TestCalendar,
  },
]

const router = new VueRouter({
  mode: 'history',
  //base: process.env.BASE_URL,
  routes
})


let loginasp = "https://xzk.wmu.edu.cn/schedulingleader";
// eslint-disable-next-line no-unused-vars
const authorbyOther = function (index) {
  var loginServer = "http://authserver.wmu.edu.cn/authserver/login";
  if (index) {
    loginasp = loginasp + index;
  }
  var url1 = loginServer + "?service=" + encodeURIComponent(loginasp);
  window.location.href = url1;
}

function getCoreUrl(url) {
  // 校验输入是否为有效字符串，避免报错
  if (typeof url !== 'string' || url.trim() === '') {
    return '';
  }

  // 找到?的位置，截取之前的部分
  const queryIndex = url.indexOf('?');
  // 如果没有?，直接返回原URL；否则返回?之前的部分
  return queryIndex > -1 ? url.substring(0, queryIndex) : url;
}


router.beforeEach(async (to, form, next) => {

  if (to.matched.length === 0) {  // 如果未匹配到路由
    form.name ? next({ name: form.name }) : next('/404');
  }
  else {

    if (to.path == "/404") {
      next();
    }
    else if (store.getters.user.id) {
      // 说明已经登录了
      next();
    }
    else {
      if (process.env.NODE_ENV === "development") {
        // 如果测试版本
        const abpConfig = await store.dispatch(
          "app/applicationConfiguration"
        );
        await store.dispatch("user/setId", abpConfig.currentUser.id);
        await store.dispatch("user/getInfo");
        next();
        // await this.dateChange();
      }
      else if (to.query && to.query.ticket) {
        //有ticket；
        const ticket = to.query.ticket;

        const currentUrl = getCoreUrl(window.location.href);
        const res = await passlessLogin({
          ticket: ticket,
          url: currentUrl,
        });
        if (res) {
          if (res.state == 1) {
            const abpConfig = await store.dispatch(
              "app/applicationConfiguration"
            );
            await store.dispatch("user/setId", abpConfig.currentUser.id);
            await store.dispatch("user/getInfo");
            next();
          }
          else if (res.state == 2) {
            Message({
              message: res.msg,
              type: 'error',
              duration: 5 * 1000
            })
          }
          else {
            let indexadd = to.path;
            if (indexadd) {
              authorbyOther(indexadd);
            }
            else {
              authorbyOther()
            }

          }
        }
      }
      else {
        let indexadd = to.path;
        if (indexadd) {
          authorbyOther(indexadd);
        }
        else {
          authorbyOther()
        }
      }
    }
  }
})


export default router
